import { inViewFade, inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import DotPaginationStyles from '@stories/Components/DotPagination/DotPagination.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { m } from 'framer-motion';
import { mix } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: ${mix(0.25, brand.grey.otherGrey, brand.white)};
  --fgColor: ${brand.black};

  position: relative;
  background: var(--bgColor);
  color: var(--fgColor);
  overflow: hidden;

  &[data-theme='darkGrey'] {
    --bgColor: ${brand.grey.grey6};
    --fgColor: ${brand.white};
  }
  
  &[data-bg='white'] {
    --accentColor: ${brand.blue.base};
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
    --fgColorAlt: ${brand.grey.grey5};
    margin: var(--sectionSpacing) 0;
  }

  &:not([data-bg='white']) {
    padding: var(--sectionSpacing) 0;
  }
    
  &:not([data-bg='white']) {
    padding: var(--sectionSpacing) 0;
  }

  &[data-bg='lightGrey'] {
    --accentColor: ${brand.blue.base};
    --bgColor: ${mix(0.25, brand.grey.otherGrey, brand.white)};
    --fgColor: ${brand.black};
    --fgColorAlt: ${brand.grey.grey5};
  }

  &[data-bg='grey'] {
    --accentColor: ${brand.blue.base};
    --bgColor: ${brand.grey.grey3};
    --fgColor: ${brand.black};
    --fgColorAlt: ${brand.black};
  }

  &[data-bg='black'] {
    --accentColor: ${brand.blue.base};
    --bgColor: ${brand.grey.grey6};
    --fgColor: ${brand.white};
    --fgColorAlt: ${brand.white};
  }
`;
const Inner = styled.div `
  ${baseGrid};
`;
const Title = styled.h2 `
  ${h3};
  margin: 0;
  grid-column: 1 / span 12;
  grid-row: 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
    grid-row: 1;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};
  grid-column: 1 / span 12;
  grid-row: 2;
  margin: 0;

  @media ${from(Device.TabletLarge)} {
    grid-column: 7 / span 6;
    grid-row: 1;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const ItemListWrapper = styled.div `
  grid-column: 1 / span 12;
  grid-row: 3;
  margin-top: var(--introSpacing);
  margin-left: calc(var(--gutterWidth) / 2 * -1);
  margin-right: calc(var(--gutterWidth) / 2 * -1);

  ${inViewFade({ delay: 0.15, duration: 0.3 })};

  @media ${from(Device.TabletLarge)} {
    grid-row: 2;
  }
`;
const ItemList = styled(m.div) `
  display: flex;
  max-width: var(--listWidth);

  [data-overflow='false'] & {
    --listWidth: 251px;

    @media ${from(Device.TabletSmall)} {
      --listWidth: 100vw;
    }
  }

  [data-overflow='true'] & {
    --listWidth: 251px;

    @media ${from(Device.TabletSmall)} {
      --listWidth: 85vw;
    }

    @media ${from(Device.TabletLarge)} {
      --listWidth: 85vw;
    }

    @media ${from(Device.DesktopLarge)} {
      --listWidth: 90vw;
    }
  }
`;
const Item = styled.div `

  display: block;
  flex: 0 0 var(--itemWidth);
  padding: 0 calc(var(--gutterWidth) / 2) 5px;
  @media ${from(Device.DesktopLarge)} {
    --gutterWidth: 32px;
  }
`;
const PaginationWrapper = styled.div `
  display: flex;
  grid-column: 1 / span 12;
  grid-row: 4;
  justify-self: flex-start;
  margin-top: 24px;

  @media ${from(Device.TabletLarge)} {
    margin-top: 48px;
    grid-row: 3;
  }

  ${DotPaginationStyles.Container} {
    --colorInactive: ${brand.grey.grey2};
    --colorActive: ${brand.black};
    --direction: row;
  }
`;
const ControlsWrapper = styled.div `
  display: flex;
  gap: 8px;
  grid-column: 1 / span 12;
  grid-row: 4;
  justify-self: flex-end;
  margin-top: 24px;

  @media ${from(Device.TabletLarge)} {
    gap: 32px;
    margin-top: 48px;
    grid-row: 3;
  }
`;
const ApproachSectionStyles = {
    Container,
    Content,
    ControlsWrapper,
    Inner,
    Item,
    ItemList,
    ItemListWrapper,
    PaginationWrapper,
    Title,
};
export default ApproachSectionStyles;
